import * as angular from "angular";
import {IController} from "angular";

export class selfPickupTimelineListCtrl implements IController {

  infiniteScroll: any;

  /* @ngInject */
  constructor() {
  }

}

angular
  .module('bringoz.admin.self-pickups')
  .component('selfPickupTimelineList', {
    bindings: {
      infiniteScroll: '<'
    },
    template: require('./self-pickup-timeline-list.html').default,
    controller: selfPickupTimelineListCtrl
  });
